import { writable } from 'svelte/store';

function crearUsuario() {
    const { subscribe, update } = writable({
        usuario: '',
        conectado: false,
        rol: 0,
        token: '',
        tokenUsuario:'',
        resesion: false,
        mensaje: '',
        user_id:''
    });

    return {
        subscribe,
        login: (x) => update((n) => {
            n.usuario = x.usuario;
            n.conectado = true;
            n.rol = x.rol;
            n.token = x.token;
            n.tokenUsuario = x.tokenUsuario;
            n.resesion = false;
            n.user_id=x.user_id;
            return n;
        }),
        retoken: (t) => update((n) => {
            n.token = t;
            return n;
        }),
        resesion: (m) => update((n) => {
            n.resesion = true;
            n.mensaje = m;
            return n;
        }),
        logout: () => update((n) => {
            n.usuario = '';
            n.conectado = false;
            n.token = '';
            return n;
        })
    };
}

export const usucon = crearUsuario();


function crear_cliente_web() {
    
    const { subscribe, update } = writable({
        client_id: '',
        redirect_url: '',
        state: '',
        response_type: '',
    })

    return {
        subscribe,
        actualizar: (x) => {
            update(() => ({ ...x }))
        }
    }
}


export const sto_cliente_web = crear_cliente_web()